<template>
  <div
    v-tooltipable
    class="w-20 cursor-pointer overflow-hidden rounded-sm border border-gray-300 bg-white pt-0-5 pl-1-5 text-ellipsis whitespace-nowrap text-gray-600"
    @click.stop="copyToClipboard(modelValue)"
  >
    <span :title="modelValue">
      {{ modelValue }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { useClipboardWithMessage } from "@/hooks/clipboard";

defineProps({
  modelValue: {
    type: String,
    default: "",
  },
});
const copyToClipboard = useClipboardWithMessage();
</script>
